import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible';

// LESS ON THE SCREEN (Phase 92): show the essentials first, then "More..."
// A single reusable progressive-disclosure block used across dense pages.
export const MoreDetails = ({ label = 'More...', closeLabel = 'Show Less', children, className = '', testId = 'more-details', variant = 'light' }) => {
  const [open, setOpen] = useState(false);
  const triggerCls = variant === 'dark'
    ? 'inline-flex items-center gap-1 min-h-11 sm:min-h-0 py-2 sm:py-0 text-sm font-bold text-white underline underline-offset-4 decoration-white/40 hover:decoration-[#f87171] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm'
    : 'inline-flex items-center gap-1 min-h-11 sm:min-h-0 py-2 sm:py-0 text-sm font-bold text-[#1a2744] underline underline-offset-4 decoration-slate-300 hover:decoration-[#b91c1c] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1a2744] rounded-sm';
  return (
    <Collapsible open={open} onOpenChange={setOpen} className={className}>
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className={triggerCls}
          data-testid={`${testId}-trigger`}
          aria-expanded={open}
        >
          {open ? closeLabel : label}
          <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="overflow-hidden data-[state=open]:animate-in data-[state=closed]:animate-out">
        <div className="pt-3" data-testid={`${testId}-content`}>
          {children}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};
